/* global localStorage:false */
(function () {
  "use strict";

  angular
    .module("admin.post.logs", ["admin.post.logs.service"])
    .controller("PostLogsAdminCtrl", PostLogsAdminCtrl);

  /** @ngInject */
  function PostLogsAdminCtrl($scope, $stateParams, $state, PostLogsService) {
    var vm = this;
    vm.create = false;
    vm.items = [];

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.usersPerPage = 25;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    vm.back = function () {
      if ($stateParams.returnUrl) {
        window.location = $stateParams.returnUrl;
      } else {
        $state.go("admin.posts");
      }
    };

    reloadPagination();
    load(1);

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      PostLogsService.list($stateParams.parentId, vm.oldPage, 25).then(
        function (result) {
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct;
          }

          vm.items = result.results;
        }
      );
    }

    vm.pageChanged = function (newPage) {
      load(newPage);
    };

    vm.showDescription = function (item) {
      $("#myModal").modal("show");
      $("#myModal").on("shown.bs.modal", function () {
        $("#description").text(item);
      });
    };
  }
})();
